import { ToolPageShell } from '@/shared/seo'
import { PovernutForm } from './PovernutForm'

export function PovernutPage() {
  return (
    <ToolPageShell utilityKey="povernut">
      <PovernutForm />
    </ToolPageShell>
  )
}
